export default "__VITE_ASSET__DksgC241__"